import img1 from '/static/img/experience/traffic/service/img1.png'
import img2 from '/static/img/experience/traffic/service/img2.png'
import img3 from '/static/img/experience/traffic/service/img3.png'
const servicesList = [
    {
        id: 1,
        img: img1,
        title: 'Takeoff & Landing VIP Service',
        desc: 'Pick-up service: guide guests to complete the immigration formalities, arrange for special assistance in baggage claim, and escort them to the designated place by special car.'
    },
    {
        id: 2,
        img: img2,
        title: 'VIP lounge services',
        desc: 'The VIP Lounge provides a private and comfortable waiting space for VIP guests. It is equipped with a wide range of luxury facilities, a selection of gourmet food and beverages, as well as a separate work area with business facilities to facilitate the handling of business affairs.'
    },
    {
        id: 3,
        img: img3,
        title: 'Security screening services',
        desc: 'The opening of an exclusive fast-track security check channel reduces guests\' waiting time in line, fully protects privacy, and makes the security check process efficient and comfortable.'
    }
]

export default {
    servicesList
}